import Vue from 'vue'
import moment from 'moment'

const $filters = {
    tc (value, data) {
        return $filters.capitalize(window.vueapp.$t(value, data))
    },
    capitalize (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    },
    capitalizeAll (value) {
        return value.split(' ').map(item => $filters.capitalize(item)).join(' ')
    },
    toCapitalize (str) {
        return $filters.capitalize(str.toLowerCase())
    },
    formatNumber (value, currency = '') {
        // format number 1234567 to 1,234,567
        try {
            return value.toString()
                .replace(/\D/g, '')
                .replace(/\B(?=(\d{3})+(?!\d))/g, currency === 'USD' ? ',' : '.')
        } catch (e) {
            return ''
        }
    },
    formatDateTime (date) {
        if (!date) return null
        // 2019-05-17T08:16:58.310Z"
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDateTimeISO (date) {
        if (!date) return null
        // 2019-05-17T08:16:58.310Z"
        return moment.utc(date).local().format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate (date) {
        if (!date) return null
        // 2019-05-17T08:16:58.310Z"
        return moment(date).format('YYYY-MM-DD')
    },
    formatTime (time) {
        if (!time) return null
        return moment(time).format('HH:mm:ss')
    },
    formatTimeHM (time) {
        if (!time) return null
        return moment.utc(time).local().format('HH:mm')
    },
    toHMS (sec) {
        if (!sec) return '0'
        sec = parseInt(sec, 10)
        let hours = Math.floor(sec / 3600)
        let minutes = Math.floor((sec - (hours * 3600)) / 60)
        let seconds = sec - (hours * 3600) - (minutes * 60)
        if (hours < 10) {
            hours = '0' + hours
        }
        if (minutes < 10) {
            minutes = '0' + minutes
        }
        if (seconds < 10) {
            seconds = '0' + seconds
        }
        return hours + ':' + minutes + ':' + seconds
    },
    replaceSpecialCharacters (string, replaceBy) {
        if (!replaceBy) {
            replaceBy = '-'
        }
        string = string.replace(/\W+(?!$)/g, replaceBy).toLowerCase()
        string = string.replace(/\W$/, '').toLowerCase()
        return string
    },
    avatarName (value) {
        const max = 2
        if (!value) {
            return ''
        }
        let split = value.split(' ')
        if (split.length < 2) {
            return value.length < max ? value.toUpperCase() : value.substring(0, max).toUpperCase()
        }
        let shortName = ''
        let length = split.length > max ? max : split.length
        for (let i = 0; i < length; i++) {
            shortName += split[i].charAt(0)
        }
        return shortName.toUpperCase()
    }
}

// define default filters
Vue.filter('capitalize', $filters.capitalize)
Vue.filter('capitalizeAll', $filters.capitalizeAll)
Vue.filter('toCapitalize', $filters.toCapitalize)
Vue.filter('formatNumber', $filters.formatNumber)
Vue.filter('formatDateTime', $filters.formatDateTime)
Vue.filter('formatDateTimeISO', $filters.formatDateTimeISO)
Vue.filter('formatDate', $filters.formatDate)
Vue.filter('formatTime', $filters.formatTime)
Vue.filter('formatTimeHM', $filters.formatTimeHM)
Vue.filter('toHMS', $filters.toHMS)
Vue.filter('replaceSpecialCharacters', $filters.replaceSpecialCharacters)
Vue.filter('avatarName', $filters.avatarName)

Vue.prototype.$filters = $filters
Vue.prototype.$f = $filters

export default $filters
